import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export const useHashScroll = () => {
  const [isPending, setIsPending] = useState(false)
  const { hash } = useLocation()

  const attemptsNum = 200
  useEffect(() => {
    if (hash && hash !== '#top') {
      setIsPending(true)
      let attempts = 0

      const checkAndScroll = () => {
        const id = hash.replace('#', '')
        const element = document.getElementById(id)
        const imgs = document.querySelectorAll('img')
        const allLoaded = Array.from(imgs).every(img => img.complete)

        if (element && allLoaded) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' })
          // Piccolo delay per sicurezza prima di togliere lo spinner
          setTimeout(() => setIsPending(false), 300)
        } 
        else if (attempts < attemptsNum) {
          attempts++
          setTimeout(checkAndScroll, 100)
        } 
        else {
          setIsPending(false)
        }
      }

      checkAndScroll()
    }
  }, [hash])

  // Restituiamo isPending così la pagina sa quando mostrare il waiter
  return isPending
}
